export default {
    SubordinateCompanies: {
        Header: {
          Name: 'Company Name',
          Status: 'Status',
          AffiliatedCompany: 'Parent Company',
          AddCompany: 'Add New Company'
        },
        table: {
          OrderNumber: 'Count',
          CompanyCode: 'Company Code',
          Name: 'Company Name',
          AffiliatedCompany: 'Parent Company',
          Group: 'Group',
          Status: 'Status',
          Action: 'Action'
        },
        Form: {
          Name: 'Company Name',
          CompanyCode: 'Company Code',
          Group: 'Parent Group',
          ParentCompany: 'Parent Company',
          LegalPerson: 'Legal Representative Name',
          UnifiedSocialCreditCode: 'Unified Social Credit Code',
          PictureOfBusinessLicense: 'Business License Image',
          ps: 'Supports JPG/JPEG/PNG format, and file size should not exceed 2M',
          ps1: 'Please enter the company name',
          EditCompany: 'Edit Company',
          NewCompany: 'New Company'
        }
      },
};
